export default __webpack_public_path__ + "static/home_cards-466e5b613c75187e7dc8039776d33271.png";